import { render, staticRenderFns } from "./RelativeRelationFloatBtns.vue?vue&type=template&id=69035514&"
import script from "./RelativeRelationFloatBtns.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports